import { getBookingColumns } from "../../../Data/Booking/BookingHistory";
import React, {
  Fragment,
  useState,
  useEffect,
  useLayoutEffect,
  useContext,
} from "react";
import AssignDriver from "../../Driver/AssignDriver";
import CommonToolTip from "../../Common/Component/CommonToolTip";
import { Link, useNavigate } from "react-router-dom";
import ActionOptions from "../../Common/Component/ActionOptions";
import QuickActions from "./QuickActions";
import moment from "moment";
import StatusIcons from "../../../CommonElements/StatusIcons";
import DataTable from "react-data-table-component";
import EditBookCab from "./EditBookCab";
import SharedDataContext from "../../../_helper/SharedData";
import CancelBooking from "./CancelBooking";
import { getBookingById } from "../../../Services/Booking.service";
import { getUserRole, showAlert } from "../../../Services/Shared.service";
import { Spinner } from "../../../AbstractElements";
import { Accountant, OnboardingAgent } from "../../../Data/SideMenu/RouteMapping";
import { Row } from "reactstrap";
import AddNewButton from "../../Common/Component/AddNewButton";
import CustomizerContext from "../../../_helper/Customizer";
import BookEdit from "./bookEdit";
import AssignVendor from "../../Vendor/AssignVendor";
const BookingTable = (props) => {
  const [bookingObj, setBookingObj] = useState({});
  const [assignDriverBookingObj, setAssignDriverBookingObj] = useState({});
  const [editType, setEditType] = useState(null);
  const [editBookCabModal, seteditBookCabModal] = useState(false);
  
  const toggleBookCabModal = () =>{
      // if(editBookCabModal){setBookingObj({})}
     seteditBookCabModal(!editBookCabModal)}
  const [assignDriverModal, setassignDriverModal] = useState(false);
  const toggleAssignDriverModal = () =>
    setassignDriverModal(!assignDriverModal);
  const [vendorBookingObj, setVendorBookingObj] = useState({}); 
  const toggleAssignVendorModal = () =>
    setassignVendorModal(!assignVendorModal);
  const [assignVendorModal, setassignVendorModal] = useState(false);
  const [cancelBookingModal, setCancelBookingModal] = useState(false);
  const toggleCancelBookingModal = () =>
    setCancelBookingModal(!cancelBookingModal);

  const { cityData, airportData } = useContext(SharedDataContext);
  const { setShowApiLoader } = useContext(SharedDataContext);
  const { mix_background_layout } = useContext(CustomizerContext);

  const userRole = getUserRole()
  const history = useNavigate();

  const onClickEditOrRebook = (bookingId, editType) => {
    getBookingById(bookingId)
      .then((bookingRes) => {
        const data = bookingRes.data;
        if (data) {
          setEditType(editType);
          setBookingObj(data);
          toggleBookCabModal();
        }
      })
      .catch((err) => {
        showAlert("error", "Something went wrong");
        setShowApiLoader(false);
      });
  };

  const processData = props.bookingData.map((element, index) => {
    console.log(">>>> BOOKING TABLE VALUE AS ELEMMENT IS :: ", element)
    return {
      bookingObject: element,
      booking_number: (
        <Link
          to={`${process.env.PUBLIC_URL}/booking/booking-info/${element.id}`}
          onClick={() => props.setPageNumber(props.pagination)}
          state={{ previousUrl: window.location.pathname, filterdata: props.filterData, searchdata: props.searchData }}
          style={{color: element.vendorCancelled === true ? "red" : ""}}
        >
          {element.megaCabsBookingNo}
        </Link>
      ),
      pickup_time: element.pickUpDateTime
        ? moment(new Date(element.pickUpDateTime)).format("MMM DD HH:mm")
        : "-",
      customer_name: element.custName ? element.custName : "-",
      phone_number: (
        <Link
          to={`${process.env.PUBLIC_URL}/customers/customer-profile/${element.custId}`}
          onClick={() => props.setPageNumber(props.pagination)}
          state={{ previousUrl: window.location.pathname, filterdata: props.filterData, searchdata: props.searchData }}
        >
          {element.custMobile}
        </Link>
      ),
      pickup_location: element.pickUpAddress ? (
        <>
          <span
            id={"pickupLocation" + index}
            style={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {element.pickUpAddress}
          </span>
          <CommonToolTip
            options={{
              placement: "left",
              target: "pickupLocation" + index,
            }}
          >
            {element.pickUpAddress}
          </CommonToolTip>
        </>
      ) : (
        "-"
      ),
      drop_location: element.destAddress ? (
        <>
          <span
            id={"dropLocation" + index}
            style={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {element.destAddress.includes("Kempegowda")
              ? "Kempegowda Airport"
              : element.destAddress}
          </span>
          <CommonToolTip
            options={{
              placement: "left",
              target: "dropLocation" + index,
            }}
          >
            {element.destAddress}
          </CommonToolTip>
        </>
      ) : (
        "-"
      ),
      status: element.currentBookingStatusType ? (
        <>
          <span className="status-icon">
            <span id={"statusIcons" + index}>
              <StatusIcons statusType={element.currentBookingStatusType} />
            </span>
            <CommonToolTip
              options={{
                placement: "left",
                target: "statusIcons" + index,
              }}
            >
              {element.currentBookingStatusType}
            </CommonToolTip>
          </span>
        </>
      ) : (
        "-"
      ),
      booking_via: element.bookingViaType ? element.bookingViaType : "-",
      pickup_type: element.pickupType ? element.pickupType : "-",
      car_Type: element.carType ? element.carType : "-",
      mmt_reference_id: element.mmtReferenceId ? element.mmtReferenceId : "-",
      action: (
        <ActionOptions key={index}>
          <QuickActions
            setBookingObj={setBookingObj}
            element={element}
            reasonData={props.reasonData}
            toggleBookCabModal={toggleBookCabModal}
            toggleAssignVendorModal={toggleAssignVendorModal}
            setVendorBookingObj={setVendorBookingObj}
            setAssignDriverBookingObj={setAssignDriverBookingObj}
            onSubmitData={props.onSubmitData}
            toggleAssignDriverModal={toggleAssignDriverModal}
            toggleCancelBookingModal={toggleCancelBookingModal}
            onClickEditOrRebook={onClickEditOrRebook}
          />
        </ActionOptions>
      ),
    };
  });

  const [fixedHeaderScrollHeight, setfixedHeaderScrollHeight] = useState(() => {
    return "57vh";
  });

  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth <= 575.98) {
        setfixedHeaderScrollHeight(51 + "vh");
      } else {
        setfixedHeaderScrollHeight(() => {
          return 57 + "vh";
        });
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const columns = getBookingColumns(props.bookingData)

  const ExpandedComponent = ({ data }) => {
    // return <pre>{JSON.stringify(data.bookingObject, null, 2)}</pre>
    return <Row style={{ padding: "20px 0px", margin: "0px", backgroundColor: data.bookingObject.hasInvoiceCorrected === true ? mix_background_layout === "dark-only" ? "rgba(23, 49, 46, 1)" : "#e0f2f1" : "" }}>
      <div className="col-lg-3">
        <span style={{ fontWeight: "bold" }}>Booking Time : </span>{data.bookingObject.createdOn ? moment(data.bookingObject.createdOn).format("MMM DD,YYYY HH:mm") : "-"}
      </div>
      <div className="col-lg-3">
        <span style={{ fontWeight: "bold" }}>Booking By : </span>{data.bookingObject.createdBy ? data.bookingObject.createdBy : "-"}
      </div>
      <div className="col-lg-2">
        <span style={{ fontWeight: "bold" }}>Remarks : </span>{data.bookingObject.remark ? data.bookingObject.remark : "-"}
      </div>
      <div className="col-lg-2">
        <span style={{ fontWeight: "bold" }}>OTP : </span>{data.bookingObject.otp ? data.bookingObject.otp : "-"}
      </div>
      {data.bookingObject?.tripId ? <div className="col-lg-1"><AddNewButton
        options={{
          name: "Trip Detail",
          icon: <i className="fa fa-map-marker"></i>,
          title: "Trip Detail",
          onclickEvent: () => {
            history(
              `${process.env.PUBLIC_URL}/trips/trip-info/${data.bookingObject?.tripId}`
            );
          },
        }}
      ></AddNewButton></div> : null}
    </Row>
  }

  return (
    <div >
      <div className="table-responsive booking-table">
        <DataTable
          columns={userRole.some((element) => element != Accountant || element != OnboardingAgent) ? columns : columns.slice(0, columns.length - 1)}
          data={processData}
          fixedHeader
          fixedHeaderScrollHeight={fixedHeaderScrollHeight}
          pagination
          paginationPerPage={props.paginationPerPage}
          paginationDefaultPage={props.pageNumber}
          paginationTotalRows={props.paginationTotalRows}
          onChangePage={props.onChangePage}
          onChangeRowsPerPage={props.onChangeRowsPerPage}
          paginationServer
          progressPending={props.loader}
          progressComponent={<div className="loader-box" style={{ height: fixedHeaderScrollHeight }}>
            <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
          </div>}
          expandableRows
          expandableRowsComponent={ExpandedComponent}
          theme={mix_background_layout == "dark-only" ? "dark" : "default"}
          conditionalRowStyles={[
            {
              when: (row) => row.bookingObject?.hasInvoiceCorrected === true,
              style: (row) => ({
                backgroundColor: mix_background_layout === "dark-only" ? "rgba(23, 49, 46, 1) !important" : "#e0f2f1",
                borderLeft: "4px solid #00897b",
              }),
            },
          ]}
        />
      </div>
      {/* <EditBookCab
        LargeModaltoggle={toggleBookCabModal}
        title={"Create a new booking"}
        Large={editBookCabModal}
        bookingData={bookingObj}
        cityData={cityData}
        airportData={airportData}
        onSubmitData={props.onSubmitData}
        editType={editType}
        setShowApiLoader={props.setShowApiLoader}
      /> */}
      <BookEdit
       LargeModaltoggle={toggleBookCabModal}
       title={"Create a new booking"}
       Large={editBookCabModal}
       bookingData={bookingObj}
       cityData={cityData}
       airportData={airportData}
       onSubmitData={props.onSubmitData}
       editType={editType}
       setShowApiLoader={props.setShowApiLoader}
      />

      <AssignDriver
        LargeModaltoggle={toggleAssignDriverModal}
        title={"Assign Driver"}
        Large={assignDriverModal}
        setShowApiLoader={props.setShowApiLoader}
        assignDriverBookingObj={assignDriverBookingObj}
        onSubmitData={props.onSubmitData}
      />
      <CancelBooking
        LargeModaltoggle={toggleCancelBookingModal}
        title={"Trip Cancellation"}
        Large={cancelBookingModal}
        bookingData={bookingObj}
        reasonData={props.reasonData}
        onSubmitData={props.onSubmitData}
        setShowApiLoader={props.setShowApiLoader}
      />
      <AssignVendor
        LargeModaltoggle={toggleAssignVendorModal}
        title={"Assign Vendor"}
        Large={assignVendorModal}
        bookingId = {vendorBookingObj.id}
        setShowApiLoader={props.setShowApiLoader}
        vendorBookingObj={vendorBookingObj}
        onSubmitData={props.onSubmitData}
      />
    </div>
  );
};
export default BookingTable;
